import { render, staticRenderFns } from "./bankCode.vue?vue&type=template&id=4b90186a&scoped=true"
import script from "./bankCode.vue?vue&type=script&lang=js"
export * from "./bankCode.vue?vue&type=script&lang=js"
import style0 from "./bankCode.vue?vue&type=style&index=0&id=4b90186a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b90186a",
  null
  
)

export default component.exports